module.exports = __webpack_public_path__ + "img/pappyon-icon.5b494043.png";